(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('av-vehicle-finder-v3')) {
  customElements.define('av-vehicle-finder-v3', class extends HTMLElement {
    async connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.catalog = this.config.catalog;
      this.modelCatalog = this.config.models;
      this.fixedMake = this.catalog.find(make => make.handle === this.dataset.collectionHandle);
      this.make = this.querySelector('[data-make]');
      this.model = this.querySelector('[data-model]');
      this.year = this.querySelector('[data-year]');
      this.form = this.querySelector('form');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[data-status]');
      const lang = document.documentElement.lang.slice(0, 2);
      const messages = {
        en: {empty:'No matching products for this make in this collection.', unknown:'Choose a make from the list.', ready:'Search stays within this collection. Vehicle-specific results depend on the listing. General-use accessories may also appear: check dimensions, voltage, battery type and the selected variant before ordering.', year:'Select a listed model and its year to refine the results, or clear the model to search by make alone.', unavailable:'No products in this collection', models:'Model and year are available only where supplied in the listing.'},
        de: {empty:'Keine passenden Produkte für diese Marke in dieser Kollektion.',unknown:'Wählen Sie eine Marke aus der Liste.',ready:'Die Suche bleibt in dieser Kollektion. Allgemein verwendbare Artikel können ebenfalls erscheinen. Prüfen Sie Maße, Spannung, Batterietyp und Variante vor der Bestellung.',year:'Wählen Sie Modell und Baujahr oder löschen Sie das Modell für eine Markensuche.',unavailable:'Keine Produkte in dieser Kollektion',models:'Modell und Baujahr sind nur verfügbar, wenn sie im Angebot angegeben sind.'},
        fr: {empty:'Aucun produit correspondant à cette marque dans cette collection.',unknown:'Choisissez une marque dans la liste.',ready:'La recherche reste dans cette collection. Des accessoires à usage général peuvent aussi apparaître : vérifiez dimensions, tension, type de batterie et variante avant de commander.',year:'Sélectionnez le modèle et son année, ou effacez le modèle pour rechercher par marque.',unavailable:'Aucun produit dans cette collection',models:'Le modèle et l’année sont disponibles uniquement lorsqu’ils sont indiqués dans la fiche.'},
        pt: {empty:'Nenhum produto encontrado para esta marca nesta coleção.',unknown:'Selecione uma marca da lista.',ready:'A busca permanece nesta coleção. Acessórios de uso geral também podem aparecer: confira medidas, tensão, tipo de bateria e variante antes de comprar.',year:'Selecione um modelo e seu ano ou limpe o modelo para buscar apenas pela marca.',unavailable:'Sem produtos nesta coleção',models:'Modelo e ano estão disponíveis somente quando informados no cadastro.'}
      };
      this.messages = messages[lang] || messages.en;
      if (this.fixedMake) {
        this.make.closest('div').hidden = true;
        this.form.classList.add('av-vehicle__form--brand');
        const intro = {en:'Choose your model from the products in this collection. Add a year where available, or browse all products below.',de:'Wählen Sie ein Modell aus dieser Kollektion. Ergänzen Sie das Baujahr, sofern verfügbar, oder durchsuchen Sie alle Produkte unten.',fr:'Choisissez un modèle proposé dans cette collection. Ajoutez l’année si disponible ou parcourez tous les produits ci-dessous.',pt:'Escolha um modelo presente nesta coleção. Informe o ano quando disponível ou veja todos os produtos abaixo.'};
        this.querySelector('.av-vehicle__intro > p:last-child').textContent = intro[lang] || intro.en;
      }
      try {
        let tags = this.config.tags || [];
        if (tags.length >= 1000) tags = await this.completeTags();
        this.tags = new Set(tags);
        this.entries = [...this.tags].map(tag => this.parse(tag)).filter(Boolean);
        this.options('[data-makes]', this.catalog.map(make => ({value:make.name, label:this.tags.has(make.code) ? '' : this.messages.unavailable})));
        this.make.addEventListener('input', () => this.changeMake());
        this.model.addEventListener('input', () => this.changeModel());
        this.year.addEventListener('input', () => this.validate());
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          const make = this.currentMake();
          if (!make || this.button.disabled) return;
          const url = this.collectionUrl();
          const entry = this.selected()[0];
          const model = this.currentModel();
          const tag = this.model.value.trim() ? (this.year.value.trim() ? entry.tag : model.tag) : make.code;
          url.pathname = url.pathname.replace(/\/$/,'') + '/' + this.slug(tag);
          const current = new URL(location.href);
          for (const [key,value] of current.searchParams) {
            if (key === 'sort_by' || key.startsWith('filter.')) url.searchParams.append(key,value);
          }
          location.assign(url.toString());
        });
        const activeTags = this.config.active || [];
        const activeEntry = activeTags.map(tag=>this.parse(tag)).find(Boolean);
        const activeModel = this.modelCatalog.find(model=>activeTags.includes(model.tag));
        const activeMake = this.catalog.find(make=>activeTags.includes(make.code) || make.code === activeModel?.code);
        if (activeEntry || activeMake || activeModel) {
          this.make.value = (this.fixedMake || activeEntry?.make || activeMake).name;
          this.changeMake();
          if (activeModel) { this.model.value = activeModel.name; this.changeModel(); }
          if (activeEntry) {
            this.model.value = activeEntry.model;
            this.changeModel();
            this.year.value = activeEntry.year;
          }
          this.querySelector('[data-reset]').hidden = false;
         } else {
          if (this.fixedMake) this.make.value = this.fixedMake.name;
          this.changeMake();
        }
        this.validate();
        this.form.hidden = false;
      } catch {
        this.status.textContent = this.config.error;
        this.querySelector('[data-reset]').hidden = false;
      }
    }
    normalize(value) { return value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
    slug(value) { return this.normalize(value).replace(/[^a-z0-9-]+/g,'-').replace(/^-+|-+$/g,''); }
    currentMake() {
      if (this.fixedMake) return this.fixedMake;
      const value = this.normalize(this.make.value);
      return this.catalog.find(make=>[make.name,...make.aliases].some(alias=>this.normalize(alias)===value));
    }
    modelValue() {
      let value = this.normalize(this.model.value);
      const make = this.currentMake();
      for (const alias of make ? [make.name, ...make.aliases] : []) {
        const prefix = this.normalize(alias) + ' ';
        if (value.startsWith(prefix)) { value = value.slice(prefix.length); break; }
      }
      return value;
    }
    currentModel() {
      const make = this.currentMake(), value = this.modelValue();
      return this.modelCatalog.find(model => model.code === make?.code && (this.normalize(model.name) === value || this.normalize(model.name) === this.normalize(make.name) + ' ' + value));
    }
    parse(tag) {
      const match = /^Vehicle (\d{4}) (.+)$/.exec(tag);
      if (!match) return null;
      for (const make of this.catalog) for (const alias of make.aliases) {
        if (match[2].startsWith(alias+' ')) return {tag,year:match[1],make,model:match[2].slice(alias.length+1)};
      }
      return null;
    }
    collectionUrl() {
      const url = new URL(this.dataset.collectionUrl,location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      return url;
    }
    async completeTags() {
      let page=1;
      const tags=new Set(),seen=new Set();
      while(page && !seen.has(page)) {
        seen.add(page);
        const url=this.collectionUrl();
        url.searchParams.set('view','av-vehicle-index');
        url.searchParams.set('page',String(page));
        const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});
        if(!response.ok)throw Error('Collection filter unavailable');
        const data=await response.json();
        for(const productTags of data.tags) for(const tag of productTags)tags.add(tag);
        page=data.next;
      }
      return [...tags];
    }
    options(selector,values,numeric=false) {
      const list=this.querySelector(selector);
      list.replaceChildren();
      const unique=new Map(values.map(value=>{const item=typeof value==='string'?{value}:value;return [item.value,item];}));
      for(const item of [...unique.values()].sort((a,b)=>numeric?Number(b.value)-Number(a.value):a.value.localeCompare(b.value))) {
        const option=document.createElement('option');
        option.value=item.value;
        if(item.label)option.label=item.label;
        list.append(option);
      }
    }
    changeMake() {
      this.model.value=''; this.year.value='';
      const make=this.currentMake();
      const entries=this.entries.filter(entry=>entry.make===make);
      const available = this.modelCatalog.filter(model => model.code === make?.code && this.tags.has(model.tag));
      this.options('[data-models]', [...new Set([...entries.map(x=>x.model),...available.map(x=>x.name)])].map(value=>({value,label:value.startsWith(make.name+' ')?value:make.name+' '+value})));
      this.options('[data-years]',[]);
      this.model.disabled=!entries.length && !available.length;
      this.year.disabled=true;
      this.validate();
    }
    changeModel() {
      this.year.value='';
      const entries=this.selected();
      this.options('[data-years]',entries.map(x=>x.year),true);
      this.year.disabled=!this.model.value.trim() || !entries.length;
      this.validate();
    }
    selected() {
      const make=this.currentMake(),model=this.modelValue(),year=this.year.value.trim();
      return this.entries.filter(entry=>entry.make===make && (!model || this.normalize(entry.model)===model) && (!year || entry.year===year));
    }
    validate() {
      const make=this.currentMake(),hasMake=make && this.tags.has(make.code);
      const hasModel=this.model.value.trim(),hasYear=this.year.value.trim();
      const model=this.currentModel();
      const byModel=model && !model.requireYear && this.tags.has(model.tag) && !hasYear;
      const valid=hasMake && (!hasModel || byModel || (hasYear && this.selected().length));
      this.button.disabled=!valid || Boolean(this.fixedMake && !hasModel);
      let message=this.messages.ready;
      if(this.make.value.trim() && !make)message=this.messages.unknown;
      else if(make && !hasMake)message=this.messages.empty;
      else if(hasModel && !byModel && (!hasYear || !this.selected().length))message=this.messages.year;
      else if(make && this.model.disabled)message+=' '+this.messages.models;
      this.status.textContent=message;
      this.make.setAttribute('aria-invalid',String(Boolean(this.make.value.trim() && (!make || !hasMake))));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
